import classNames from "classnames";

import { RightPanelMode } from "views/pages/DataPage/CardsView";
import MetadataSummaryIcon from "assets/icons/MetadataSummaryIcon";
import LabelPropagationIcon from "assets/icons/LabelPropagationIcon";

import styles from "./style.module.scss";

interface ViewToggleButtonsProps {
  currentView: RightPanelMode;
  onViewChange: (view: RightPanelMode) => void;
  needsReviewText?: string | null;
}

const ViewToggleButtons = ({
  currentView,
  onViewChange,
  needsReviewText = null,
}: ViewToggleButtonsProps) => {
  const summaryButtonClassNames = classNames(styles.toggleButton, {
    [styles.active]: currentView === "summary",
  });
  const labelsButtonClassNames = classNames(styles.toggleButton, {
    [styles.active]: currentView === "labels",
  });

  return (
    <div className={styles.viewToggleContainer}>
      <button
        className={summaryButtonClassNames}
        onClick={() => onViewChange("summary")}
      >
        <MetadataSummaryIcon />
      </button>
      <button
        className={labelsButtonClassNames}
        onClick={() => onViewChange("labels")}
      >
        <LabelPropagationIcon />
        {needsReviewText && (
          <div className={styles.needsReviewChip}>{needsReviewText}</div>
        )}
      </button>
    </div>
  );
};

export default ViewToggleButtons;
